<template>
  <div class="col-6">
    <loading-panel v-if="loading"/>
    <card class="card">
      <template slot="header">
        <div class="d-flex">
          <div class="mr-auto p-2">
            <h4 class="card-title">{{ $t('system_account.detailsTitle') }}</h4>
          </div>
          <edit-system-account-btn v-if="$auth.can({system_account: 'update'}, 'permissions')"/>
          <system-account-invitation-btn :system-account="details"
                                         v-if="$auth.can({system_account: 'update'}, 'permissions')"/>
          <el-tooltip :content="$t('system_account.delete.deleteBtnTooltip')"
                      effect="light"
                      :open-delay="300"
                      placement="bottom">
            <base-button  icon round type="danger" @click.native="handleDelete()" v-if="$auth.can({system_account: 'delete'}, 'permissions')">
              <i class="mdi mdi_icon mdi-24px mdi-close"/>
            </base-button>
          </el-tooltip>
        </div>
      </template>
      <div v-loading="loading">
        <div v-if="details">
          <system-account-details :details="details"/>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import swal from 'sweetalert2';
import SystemAccountDetails from 'src/components/SystemAccount/SystemAccountDetails';
import EditSystemAccountBtn from 'src/components/SystemAccount/EditSystemAccountBtn';
import SystemAccountInvitationBtn from 'src/components/SystemAccount/SystemAccountInvitationBtn';
import {mapActions, mapState} from "vuex";
import LoadingPanel from "@/components/LoadingPanel.vue";
import system_account from "@/store/modules/system_account";

export default {
  components: {
    LoadingPanel,
    SystemAccountDetails,
    EditSystemAccountBtn,
    SystemAccountInvitationBtn,
  },
  props: {},
  computed: {
    ...mapState({
      loading: state => state.system_account.loading,
      error: state => state.system_account.error,
      details: state => state.system_account.single,
    }),
  },
  methods: {
    ...mapActions(['GetSystemAccount', 'GetRoles', 'DeleteSystemAccount']),
    handleDelete(index, row) {
      swal({
        title: this.$t('system_account.delete.text'),
        text: this.details.username,
        buttonsStyling: false,
        confirmButtonText: this.$t('system_account.delete.actionBtnLabel'),
        cancelButtonText: this.$t('system_account.delete.cancelBtnLabel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.DeleteSystemAccount(this.details.id).then(() => {
              if (this.error == null) {
                this.$notify({
                  type: 'success',
                  message: this.$t('system_account.delete.deletedNotification', {username: this.details.username}),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
                this.$router.push({
                  name: 'system_accounts',
                }).catch(err => {
                })
              }
            }
          )

        }
      });
    },
  },
  mounted() {
    this.GetSystemAccount(this.$route.params.id)
    this.GetRoles()
  },
};
</script>
<style></style>
